var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53047 14.742H15.4723C16.293 14.742 16.9598 14.077 16.9598 13.2551V4.2682C16.9598 2.21383 15.2948 0.548828 13.2411 0.548828H6.76109C4.70797 0.548828 3.04297 2.21383 3.04297 4.2682V13.2551C3.04297 14.0763 3.70922 14.742 4.53047 14.742ZM14.0298 12.697C13.4823 12.697 13.038 12.2526 13.038 11.7045C13.038 11.1576 13.4823 10.7132 14.0298 10.7132C14.578 10.7132 15.0217 11.1576 15.0217 11.7045C15.0217 12.2532 14.578 12.697 14.0298 12.697ZM15.0211 4.39133V8.48195H10.7823V4.39133H15.0211ZM4.98109 4.39133H9.21922V8.48195H4.98109V4.39133ZM5.97297 10.7138C6.52047 10.7138 6.96422 11.1582 6.96422 11.7051C6.96422 12.2532 6.52047 12.6976 5.97297 12.6976C5.42484 12.6976 4.98109 12.2532 4.98109 11.7051C4.98109 11.1582 5.42484 10.7138 5.97297 10.7138Z",
    fill: "url(#paint0_linear_115_4800)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7845 19.4524H17.6539L14.907 15.8574H13.037L13.7833 16.8343H6.21766L6.96391 15.8574H5.09453L2.34766 19.4524H4.21641L5.18266 18.188H14.8189L15.7845 19.4524Z",
    fill: "url(#paint1_linear_115_4800)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_4800",
    x1: 3.04297,
    y1: 7.64539,
    x2: 16.9598,
    y2: 7.64539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_4800",
    x1: 2.34766,
    y1: 17.6549,
    x2: 17.6539,
    y2: 17.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.b09b4d3855b6d8f63ce99900f8af9162.svg";
export { ForwardRef as ReactComponent };